import './components/skip-links'
import Hero from './components/hero';
import Masthead from './components/masthead';
import Slider from './components/slider';
import Share from './components/share';
import ArchiveViews from './components/archive-views';
import SubMenuToggle from "./components/sub-menu-toggle";
import FadeOutImage from "./components/fade-out-image";
import TogglePeopleView from "./components/toggle-people-view";
import SearchOverlay from "./components/search-overlay";
import MobileMenu from "./components/mobile-menu";
import PrevButton from "./components/prev-button";
import Readspeaker from "./components/readspeaker";
import Escape from "./components/escape";
import MembershipForm from "./components/membership-form";
import DetectDevices from "./components/detect-devices";
import ScaleHtml5Banners from "./components/scale-html5-banners";
import MobileFixes from "./components/mobile-fixes";
import DonationFormInfo from "./components/donation-form";
import eventFilters from "./components/event-filters";
import cookieNoticeAddons from "./components/cookie-notice-addons";
import navigation from "./components/navigation";
import UpdateParagraphText from "./components/update-paragraph-text";

cookieNoticeAddons.init();
navigation( document.querySelector( '.main-menu--container' ) )
eventFilters.init();
Hero.init();
Masthead.init();
Slider.init();
Share.init();
ArchiveViews.init();
SubMenuToggle.init();
FadeOutImage.init();
TogglePeopleView.init();
SearchOverlay.init();
MobileMenu.init();
PrevButton.init();
Readspeaker.init();
Escape.init();
MembershipForm.init();
DetectDevices.init();
ScaleHtml5Banners.init();
MobileFixes.init();
DonationFormInfo.init();
UpdateParagraphText.init();
